import { render, staticRenderFns } from "./getDescription.vue?vue&type=template&id=78ba242b&scoped=true"
import script from "./getDescription.vue?vue&type=script&lang=js"
export * from "./getDescription.vue?vue&type=script&lang=js"
import style0 from "./getDescription.vue?vue&type=style&index=0&id=78ba242b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ba242b",
  null
  
)

export default component.exports